// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__1RgSg","load3":"Spinner_load3__Sc4Ul"};